import React from "react";
import { StyleSheet } from "react-native";
import { InputToolbar, InputToolbarProps } from "react-native-gifted-chat";

const GiftedChatInputToolbar = (props: InputToolbarProps) => (
  <InputToolbar {...props} containerStyle={styles.container} />
);

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#FBFBFC",
    borderRadius: 10,
    marginRight: 20,
    marginLeft: 20,
    boxShadow: "inset 2px 2px 10px rgba(166, 171, 189, 0.5)",
    minHeight: 45,
    display: "flex",
    justifyContent: "space-between",
  },
});

export default GiftedChatInputToolbar;
